import { render, staticRenderFns } from "./PmwLoader.vue?vue&type=template&id=446cda57&scoped=true&"
var script = {}
import style0 from "./PmwLoader.vue?vue&type=style&index=0&id=446cda57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446cda57",
  null
  
)

export default component.exports